import $ from 'jquery'

const jQuery = $
export { $, jQuery }
